const px = 1652 / 1012
const py = 2336 / 1414

export const S1_CC2308_Test_NT_210507 = {
  FRONT: {
    EXAM_GROUP_KEY: '05122009111',
    QR_INFO: {
      checkDigit: 9817,
      correctSize: { w: 1012 * px, h: 1414 * py },
      correctMarkers: {
        tl: { x: 28.5 * px, y: 28.5 * py },
        tr: { x: 982 * px, y: 28.5 * py },
        bl: { x: 28.5 * px, y: 1390 * py },
        br: { x: 982 * px, y: 1390 * py }
      },
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: {
        x: 795 * px,
        y: 133 * py
      },
      numCheckPosition: {
        l: 918 * px,
        t: 187 * py,
        w: 60 * px,
        h: 25 * py
      },
      clipScale: 0.8,
      isHorizontal: false,
    }
  },
  REVERSE: {
    EXAM_GROUP_KEY: '05122009122',
    QR_INFO: {
      checkDigit: 9825,
      correctSize: { w: 1012 * px, h: 1414 * py },
      correctMarkers: {
        tl: { x: 28.5 * px, y: 28.5 * py },
        tr: { x: 982 * px, y: 28.5 * py },
        bl: { x: 28.5 * px, y: 1390 * py },
        br: { x: 982 * px, y: 1390 * py }
      },
      asGray: false,
      disableWhitebarance: true,
      rotateQrPos: {
        x: 880 * px,
        y: 100 * py
      },
      numCheckPosition: {
        l: 923 * px,
        t: 257 * py,
        w: 60 * px,
        h: 25 * py
      },
      clipScale: 0.8,
      isHorizontal: false,
    }
  }
} as const
